import { action } from 'typesafe-actions';
import { HistoricoType } from './types';

interface HistoricoRequest {
  pageNo: number;
  pageSize: number;
  company: number;
  date?: string;
  atividade?: string;
  user?: string;
}
export const historicoRequest = (config: HistoricoRequest) =>
  action(HistoricoType.HISTORICO_RESQUEST, {
    config,
  });

export const historicoSuccess = (data: any) =>
  action(HistoricoType.HISTORICO_SUCCESS, { data });

export const historicoFailure = () =>
  action(HistoricoType.HISTORICO_FAILURE, {});

interface DetalheRequest {
  company: number;
  date: any;
  id: any;
}

export const detalheHistoricoRequest = (config: DetalheRequest) =>
  action(HistoricoType.DETALHE_HISTORICO_RESQUEST, {
    config,
  });

export const detalheHistoricoSuccess = (data: any) =>
  action(HistoricoType.DETALHE_HISTORICO_SUCCESS, { data });

export const detalheHistoricoFailure = () =>
  action(HistoricoType.DETALHE_HISTORICO_FAILURE, {});

export const resetPage = (make: number) =>
  action(HistoricoType.RESET_PAGE, { make });

export const cleanModal = () => action(HistoricoType.CLEAN_MODAL, {});
